export type State = {
  mode: 'light' | 'dark';
};

export enum ActionTypes {
  SWITCH_MODE = 'platformui/SWITCH_MODE',
}
